import { FC } from "react";
import { AxiosError } from "axios";

import { IErrorComponent } from "../ErrorComponent";
import { BusinessErrorIcon } from "../../../icons/errors";
import { ErrorTemplate } from "../blocks/ErrorTemplate";

export const BusinessError: FC<IErrorComponent> = (props) => {
  const err = props.error as AxiosError<{
    message?: {
      description?: string;
    };
  } | null > | null;

  const backendMessage = err?.response?.data?.message?.description;
  const resultMessage = backendMessage ?? "Попробуйте повторить запрос позже";

  return (
    <ErrorTemplate
      {...props}
      icon={BusinessErrorIcon}
      message={resultMessage}
      showTechInfo={true}
    />
  );
};
